'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const MAX_ARRAY_LENGTH = 4_294_967_295;

exports.MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH;
